import React from 'react';
import {Modal} from 'semantic-ui-react';

const MADInfoModal = ({
  typeInfo,
  value,
  MADCalculo,
}) => {
  const MADPedidos = '(((cantidad total de pedidos en los últimos 6 meses) / 24) * 52) / 12)';
  const MADVentas = '(((cantidad total vendida en los últimos 6 meses) / 24) * 52) / 12) + MAD ventas perdidas';
  const noData = `No se encuentra disponible el calculo MAD ${typeInfo}`;

  return (
    <Modal
      size='large'
      trigger={<div className='five wide column link'>{value}</div>}
      className='MAD-modal'
      closeIcon
    >
      <Modal.Header>Fórmula MAD</Modal.Header>
      <Modal.Content>
        <div>
          <strong>{`MAD ${typeInfo}`}</strong>
          <br />
          <p>{typeInfo === 'Pedidos' ? MADPedidos : MADVentas}</p>
          <br />
        </div>
        <div>
          <strong>{`${typeInfo}:`}</strong>
          <br />
          <p>{(MADCalculo && MADCalculo !== '0') ? MADCalculo : noData}</p>
          <br />
        </div>
      </Modal.Content>
    </Modal>
  );
};

export default MADInfoModal;
